import { api } from '@/core/api/';

const URL = 'api/provider/bidding';

export const getBiddingAvailableAcademicYears = (companyId) =>
  api.get(`${URL}/biddingavailableacademicyears/${companyId}`);

export const saveBiddingRequest = (academicYearId, companyId) =>
  api.post(`${URL}/savebiddingrequest/${academicYearId}/${companyId}`);

export const deleteBiddingRequest = (academicYearId, companyId) =>
  api.delete(`${URL}/deletebiddingrequest/${academicYearId}/${companyId}`);

export const getRequestDeterminationReasons = (statusId) =>
  api.get(`${URL}/requestdeterminationreasons/${statusId}`);

export const saveRequestDetermination = (payload) =>
  api.post(`${URL}/saverequestdetermination`, payload);

export const determineContractDocument = (payload) =>
  api.put(`${URL}/contractdocument/determine`, payload);

export const goBackStatusContractDocument = (contractDocumentId) =>
  api.put(`${URL}/contractdocument/gobackstatus/${contractDocumentId}`);

export const validatebiddingsections = (companyId, academicYearId) =>
  api.get(`${URL}/validatebiddingsections/${companyId}/${academicYearId}`);

export const validatesubmittedsections = (companyId, academicYearId) =>
  api.get(`${URL}/validatesubmittedsections/${companyId}/${academicYearId}`);
